import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "../../src/js/api/queryClient";
import { HeroImageWidget } from "./components/hero-image/hero-image-widget";
import { resolveMaxFileSizeBytes } from "../js/upload-limits";

function HeroImageRenderer() {
  const rootElement = document.getElementById(
    "my-profile__hero-image-widget"
  );
  if (!rootElement) return;

  createRoot(rootElement).render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <HeroImageWidget
          heroUrl={rootElement.dataset.heroUrl}
          heroPosition={rootElement.dataset.heroPosition}
          coverKey={rootElement.dataset.coverKey || null}
          coverSourceUrl={rootElement.dataset.coverSourceUrl || null}
          coverFocalLeft={rootElement.dataset.coverFocalLeft}
          coverFocalTop={rootElement.dataset.coverFocalTop}
          altText={rootElement.dataset.altText}
          // The configured upload limit, rendered by Views/MyProfile.cshtml. Never a literal
          // here — see upload-limits.js.
          maxFileSizeBytes={resolveMaxFileSizeBytes(
            rootElement.dataset.maxFileSizeBytes
          )}
        />
      </QueryClientProvider>
    </StrictMode>
  );
}

export const initHeroImage = () => {
  if (document.readyState !== "loading") {
    HeroImageRenderer();
  } else {
    document.addEventListener("DOMContentLoaded", HeroImageRenderer);
  }
};
